<script setup lang="ts">
import VacaturesDataTable from '@/features/vacatures/components/VacaturesDataTable.vue'

definePage({
  path: '/companies/:id/vacatures',
  name: 'companies.[id].vacatures',
  meta: {
    permission: {
      resource: 'Job',
      level: 'Read',
    },
  },
})

const companyId = inject<Ref<number>>('companyId')!
</script>

<template>
  <div class="relative space-y-5">
    <Card>
      <template #content>
        <VacaturesDataTable
          :company-id="companyId"
          :storage-key="`s4w-dtf:company-${companyId}-vacatures`"
        />
      </template>
    </Card>
  </div>
</template>
